/* tslint:disable:max-line-length */
/**
 * Form.io API
 * Form.io Swagger 2.0 API specification.  This API spec can be used for integrating your Form.io project into non-HTML5 programs like \"native\" phone apps, \"legacy\" and \"enterprise\" systems, embedded \"Internet of Things\" applications (IoT), and other programming languages.  Note: The URL's below are configured for your specific project and form.
 * http://blog.form.io/form-terms-of-use
 * Form.io Support
 * http://help.form.io/
 * support@form.io
 * MIT
 * http://opensource.org/licenses/MIT
 * 1.0.0
 * ycdueorllrktiww.form.io
 */

export * from './defs/Contact'; // sources: contact
export * from './defs/ContactData'; // sources: contactData
export * from './defs/Magazine'; // sources: magazine
export * from './defs/MagazineData'; // sources: magazineData
export * from './defs/Mediakit'; // sources: mediakit
export * from './defs/MediakitData'; // sources: mediakitData
export * from './defs/Publisher'; // sources: publisher
export * from './defs/PublisherData'; // sources: publisherData
export * from './defs/Attachment'; // sources: attachment
export * from './defs/AttachmentData'; // sources: attachmentData
export * from './defs/Image'; // sources: image
export * from './defs/ImageData'; // sources: imageData
export * from './defs/Address'; // sources: address
export * from './defs/AddressData'; // sources: addressData
export * from './defs/Mediakitattribute'; // sources: mediakitattribute
export * from './defs/MediakitattributeData'; // sources: mediakitattributeData
export * from './defs/Magazineissue'; // sources: magazineissue
export * from './defs/MagazineissueData'; // sources: magazineissueData
export * from './defs/Mediakitcontent'; // sources: mediakitcontent
export * from './defs/MediakitcontentData'; // sources: mediakitcontentData
export * from './defs/SearchBrowse'; // sources: SearchBrowse
export * from './defs/SearchBrowseData'; // sources: SearchBrowseData
 export * from './defs/ChooseAddData'; // sources: ChooseAddData
export * from './defs/chooseDueDates'; // sources: chooseDueDates
export * from './defs/User'; //sources: User
export * from './defs/ViewRate'; //sources: ViewRate
export * from './defs/AdRate'; //sources: ViewRate
export * from './defs/Issue'; //sources: issues
export * from './defs/AdMediaKit'; //sources: ViewRate
export * from './defs/ModifiedProperties'; //sources: ViewRate
export * from './defs/ShoppingCart'; //sources: ShoppingCart
export * from './defs/wishListLine'; //sources: wishListLine
export * from './defs/CreateOffer'; //sources: CreateOffer
export * from './defs/offerLine'; //sources: offerLine
export * from './defs/Offer'; //sources: Offer
export * from './defs/OfferData'; //sources: Offer
export * from './defs/magazineInfo'; //sources: Offer
export * from './defs/discountInfo'; //sources: Offer
export * from './defs/OfferData'; //sources: Offer
export * from './defs/offerComment'; //sources: Offer
export * from './defs/AcceptDeclineOffer'; //sources: AcceptDeclineOffer
export * from './defs/SellerAddress'; //sources: Offer
export * from './defs/AddressSeller'; //sources: AcceptDeclineOffer
export * from './defs/SellerContact';
export * from './defs/ContactAdress';
export * from './defs/ContactTelephone';
export * from './defs/TimerInfo';
export * from './defs/MfTimeSpan';
export * from './defs/SellerAddContact';
export * from './defs/TempAuthRequest';
export * from './defs/MdbSelectOptions';
export * from './defs/TelephoneType';
export * from './defs/ContactType';
export * from './defs/AdType';
export * from './defs/AdColor';
export * from './defs/AdPlacement';
export * from './defs/AdPrintSource';
export * from './defs/AdOrientation';
export * from './defs/AdUnit';
export * from './defs/Circulation';
export * from './defs/MagazineDetails';
export * from './defs/Assets';
export * from './defs/Offers';
export * from './defs/Counter';
export * from './defs/MigrateMediaKit';
export * from './defs/DowloadBatch'
export * from './defs/BofABatchOfferDetails'
export * from './defs/Tag'